/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type HandleReplyInAction = typeof HandleReplyInAction[keyof typeof HandleReplyInAction];


export const HandleReplyInAction = {
  consent: 'consent',
  decline: 'decline',
  withdraw: 'withdraw',
  dismiss: 'dismiss',
} as const;
